// hooks/useAutoLogout.js
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../redux/slices/userSlice";
import { persistor } from "../redux/store";

const useAutoLogout = (timeout = 3600000) => {
  const timer = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logoutUser = () => {
    dispatch(logout());  // Reset Redux
    persistor.purge();   // Reset persisted data
    navigate("/");       // Redirect
  };

  const resetTimer = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(logoutUser, timeout);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click"];
    events.forEach((e) => window.addEventListener(e, resetTimer));
    resetTimer();

    return () => {
      events.forEach((e) => window.removeEventListener(e, resetTimer));
      clearTimeout(timer.current);
    };
  }, []);
};

export default useAutoLogout;
